import { Component } from '@angular/core';
import { ActivationService } from '../core/services/activation.service';
import { GameService } from '../core/services/game.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NavController } from '@ionic/angular';

@Component({
    selector: 'app-activation-page',
    templateUrl: './activation-page.component.html',
    styleUrls: ['./activation-page.component.scss'],
    standalone: false
})
export class ActivationPageComponent {
  activationCode: string = '';
  errorMessage?: string;

  constructor(
    protected activationService: ActivationService,
    protected gameService: GameService,
    private nav: NavController
  ) {
    if (activationService.isActivated()) {
      this.nav.navigateRoot(['home']).then();
    }
  }

  async verifyActivationCode() {
    try {
      const isValid = await this.activationService.verifyCode(this.activationCode.toUpperCase());

      if (isValid) {
        this.activationService.setActivated();
        return this.nav.navigateRoot(['home']);
      }

      this.errorMessage = 'Whoops! Deze code is ongeldig. Probeer het opnieuw.';
    } catch (e) {
      console.error('Activation error:', e instanceof Error || e instanceof HttpErrorResponse ? e.name + ": " + e.message : e);
      alert('Er is een fout opgetreden bij het activeren van de code. Probeer het later opnieuw.');
    }
  }
}
